import { MdSend } from 'react-icons/md'

import { useContext, useEffect, useRef, useState } from 'react'
import LeadForm, { LeadFormRefType } from '../../components/lead-form/LeadForm'
import PageHeader from '../../components/pageHeader/PageHeader'
import styled from 'styled-components'
import ApplyNowHead from '../../components/heads/ApplyNowHead'
import LeadContext from '../../contexts/LeadContext'
import { useRouter } from 'next/router'
import { LoadMask } from '../../components/ui/LoadMask'
import GlobalContext from '../../contexts/GlobalContext'
import apolloClient from '../../apollo-client'
import { GET_LEADFORM_QUERY } from '../../graphql/leadForm'
import { GetStaticProps } from 'next'

export default function ApplyPage({ leadForms }: any) {
  const leadFormRef = useRef<LeadFormRefType>(null)

  const { loadScripts, setErrorMsg } = useContext(GlobalContext)
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    loadScripts('jobApplyStart')
  }, [loadScripts])
  const { submitLead, submitLeadResultData, loading } = useContext(LeadContext)
  const router = useRouter()

  const onSubmit = async () => {
    if (isSubmitting) {
      return
    }
    setIsSubmitting(true)
    const form = leadFormRef.current

    if (form && (await form.validateForm())) {
      const values = form.getFormValues()
      try {
        await submitLead(values)
      } catch {
        setErrorMsg(
          'Uh-oh! Error adding truck driver job application. Try again soon.'
        )
      }
    }
    setIsSubmitting(false)
  }

  useEffect(() => {
    const marketingKey = router.query.marketingKey
    if (submitLeadResultData && submitLeadResultData.leadId && marketingKey) {
      router.push(`/confirm/${marketingKey}`)
    }
  }, [submitLeadResultData, router])

  const getInfo = (cls: string) => {
    return (
      <div className={`text-[#444] font-lato-light ${cls}`}>
        <p>
          Companies are competing to hire drivers just like you! You can choose
          a higher paying job, with better benefits and greater home-time. Some
          companies are even offering up to $80,000-$97,500 annual salaries for
          Company Drivers and $110,000-$205,000 annually for Owner Operators.
          Check out their offers today!
        </p>

        <p>
          There is no better place than DriversJobChoice.com to find the most
          up-to-date driving opportunities available in today{`'`}s job market.
        </p>
      </div>
    )
  }

  return (
    <>
      <ApplyNowHead />
      <LoadMask active={loading}></LoadMask>
      <PageHeader
        bucket='apply/hero'
        s3FileName='default'
        isHold={false}
        staticHtml={`<div class="tc-long">
        <h1>Apply Today for Top OTR, Regional, and Dedicated Driving Jobs</h1>
      </div>`}
        enableHide={false}
      />

      <section className='max-w-[1200px] mx-auto pt-[32px] pb-[48px] px-[15px]'>
        {getInfo('max-md:hidden')}
        <div className='shadow-2xl p-5'>
          <H3 className='pb-[15px] text-center'>
            Truck Driver Job Application Form
          </H3>
          <LeadForm
            ref={leadFormRef}
            leadFormData={leadForms}
            submitBtn={
              <button
                key='submit'
                type='button'
                disabled={!leadFormRef.current?.isValidForm() || isSubmitting}
                className='disabled:bg-[#888] w-full text-[18px] font-semibold text-center inline-block px-6 py-2.5 bg-green-600 text-white text-xs leading-tight uppercase rounded shadow-md hover:bg-green-700 hover:shadow-lg focus:bg-green-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-green-800 active:shadow-lg transition duration-150 ease-in-out'
                onClick={onSubmit}
              >
                <div className='flex items-center content-center justify-center text-[16px] font-bold font-arial'>
                  <span>Submit</span>
                  <MdSend className='ml-2' />
                </div>
              </button>
            }
          ></LeadForm>
        </div>
        {getInfo('md:hidden pt-[50px]')}
      </section>
    </>
  )
}

const H3 = styled.h3`
  font-size: 1.75rem;
  font-weight: 500;
  line-height: 1.2;
  color: #444;
  font-family:
    Arial Black,
    sans-serif;
`

export async function getStaticPaths() {
  return { paths: [], fallback: true }
}

export const getStaticProps: GetStaticProps = async () => {
  try {
    const variables: any = {}

    const { data } = await apolloClient.query<any>({
      query: GET_LEADFORM_QUERY,
      variables
    })

    return {
      revalidate: 60 * 30,
      props: {
        leadForms: data.leadForms
      }
    }
  } catch {
    return {
      revalidate: 60 * 30,
      props: {
        leadForms: null
      }
    }
  }
}
